import React, { Component } from "react";
import { connect } from "react-redux";
import { SearchIcon } from "@heroicons/react/solid";
import LocaleStrings from "../../../languages/index.js";
import NewAddvertisement from "./addadvertisement";
import {
  fetchProductCategory,
  fetchProductSubcategory,
  fetchAllAdds,
  searchAdds,
  fetchProductsByCateSubCate,
  fetchallProducts,
} from "../actions/index";
import _ from "lodash";
import AllAdvertismentListing from "./allads-item";
import BaseLoader from "../../../../common/base-loader";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import Pagination from "react-js-pagination";
import { classNames } from "../../../../common/common-functions";

class AddsManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deliveredorderSearch: "",
      loaderDesc: LocaleStrings.adds_management,
      loading: true,
      pageNumber: 1,
      search: "",
    };

    // All Binded Functions
  }

  componentDidMount() {
    var parts = this.props.history.location.pathname.substring(11).split("/");
    var answer = parts[0];
    var singleNavigationRow = _.find(this.props.navigation.data, {
      href: answer,
    });

    if (singleNavigationRow == undefined) {
      this.props.history.push("/login");
    }
    this.props.fetchAllAdds(this.props.session, 0, (CallBackResponse) => {
      this.setState({ loading: false });
    });
    // Get Categories
    // this.props.fetchProductCategory(this.props.session, (callBack) => {});
    // // Get ALL ProductList
    // this.props.fetchallProducts(this.props.session, (callBack) => {});

    // // Subcategories
    // this.props.fetchProductSubcategory(this.props.session, (callBack) => {});
    // Get product
    // this.props.fetchProductsByCateSubCate(this.props.session, (callBack) => {});
  }

  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search == "") {
      this.props.fetchAllAdds(this.props.session, 0, (CallBackResponse) => {});
    } else {
      this.props.searchAdds(this.props.session, search);
    }
    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    //  console.log("pgno", pageNumber)
    if (this.state.search == "") {
      this.props.fetchAllAdds(this.props.session, pageNumber, (response) => {});
    } else {
      this.props.searchAdds(this.props.session, this.state.search, pageNumber);
    }

    this.setState({ ...this.state, pageNumber });
  };

  renderaddlist() {
    let pageDataLength = this.props.allAddListing.data.length;
    let { pageNumber } = this.state;
    var items = _.map(this.props.allAddListing.data, (values, index) => (
      <AllAdvertismentListing
        key={index}
        values={values}
        pagination={this.paginationCallback}
        pageDataLength={pageDataLength}
        currentPage={pageNumber}
      />
    ));
    return items;
  }

  render() {
    let { language } = this.props;
    return (
      <>
        {this.state.loading ? (
          <>
            <BaseLoader data={this.state.loaderDesc} />
          </>
        ) : (
          <div
            className="grid gap-4 grid-rows-1 px-6 md:grid-rows-3 sm:grid-rows-3 lg:grid-rows-1 "
            style={{
              overflowX: "hidden",
              overflowY: "hidden",
              display: "block",
            }}>
            <div className="text-2xl font-semibold text-secondary">
              {LocaleStrings.ads_management_heading}
            </div>
            <NewAddvertisement />
            <div
              className="relative md:w-6/12 xs:w-full text-ternary focus-within:text-secondary smallscreen-search"
              style={{ marginTop: -35 }}>
              <div
                className={classNames(
                  language == "en" ? "left-0 " : "right-0",
                  "absolute inset-y-0 flex items-center pointer-events-none px-1"
                )}>
                <SearchIcon className="h-5 w-5" aria-hidden="true" />
              </div>
              <input
                id="search-field"
                className={classNames(
                  language == "en" ? "pl-8 pr-3" : "pr-8 pl-3",
                  "block lg:w-6/12 xs:w-full sm:w-full h-full  py-2 border-transparent text-secondary placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm rounded-md"
                )}
                placeholder={LocaleStrings.search}
                type="search"
                name="search"
                value={this.state.search}
                onChange={this.handleSearch}
              />
            </div>
            {this.props.allAddListing &&
            this.props.allAddListing.data.length > 0 ? (
              <div className="panel-body mt-6">
                {/* <TableContent /> */}
                <div className="flex flex-col">
                  <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                      <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-custWhite">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.adImage}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.linkeditem}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Showing Position
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.action}
                              </th>
                            </tr>
                          </thead>
                          <tbody>{this.renderaddlist()}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <Pagination
                  activePage={this.state.pageNumber}
                  itemsCountPerPage={7}
                  totalItemsCount={this.props.allAddListing.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                />
              </div>
            ) : (
              <div className="mt-48 center-item">No Advertisement Found</div>
            )}

            <NotificationContainer />
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, language } = state;
  // console.log("  allAddListing:state.allAddListing", state.allAddListing);
  return {
    session,
    user,
    language,
    allAddListing: state.allAddListing,
    navigation: state.sideBarMenus,
  };
}

export default connect(mapStateToProps, {
  fetchAllAdds,
  fetchProductCategory,
  fetchProductSubcategory,
  searchAdds,
  fetchProductsByCateSubCate,
  fetchallProducts,
})(AddsManagement);
